
import { Badge } from "@/components/ui/badge";
import { type FeedbackStatus } from "@/types";

// Define fallback colors for legacy status values
const defaultStatusColors = {
  in_review: "bg-purple-500",
  planned: "bg-blue-500",
  in_progress: "bg-yellow-500",
  completed: "bg-green-500",
  rejected: "bg-red-500"
} as const;

type FeedbackStatusBadgeProps = {
  status: FeedbackStatus;
  companyStatuses?: any[];
};

const FeedbackStatusBadge = ({ status, companyStatuses = [] }: FeedbackStatusBadgeProps) => {
  // Try to find matching company status by status ID first if status is a UUID
  // (in case we're now passing the ID directly)
  let matchingStatus = null;
  
  // Check if status might be a UUID (from company_statuses.id)
  const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  
  if (uuidPattern.test(status)) {
    // Status is a UUID, try to find matching company status by ID
    matchingStatus = companyStatuses.find(s => s.id === status);
  } else {
    // Try to match by name (legacy approach)
    matchingStatus = companyStatuses.find(
      s => s.name.toLowerCase().replace(/\s+/g, '_') === status
    );
  }
  
  let bgColor = defaultStatusColors[status as keyof typeof defaultStatusColors] || "bg-gray-500";
  let displayName = typeof status === 'string' ? status.replace(/_/g, " ") : status;
  
  if (matchingStatus) {
    bgColor = matchingStatus.color ? 
      (matchingStatus.color.startsWith('#') ? 
        `bg-[${matchingStatus.color}]` : matchingStatus.color) 
      : bgColor;
    displayName = matchingStatus.name;
  }

  return (
    <Badge className={`${bgColor} text-white`}>
      {displayName}
    </Badge>
  );
};

export default FeedbackStatusBadge;
